import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { MercadoSituacaoModule } from '../situacao';

import { MercadoFilterModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule,
        MercadoSituacaoModule
    ],
    declarations: [
        MercadoFilterModalComponent
    ],
    exports: [
        MercadoFilterModalComponent
    ]
})
export class MercadoFilterModule { }
